
import { Component } from '@angular/core';

import { AlertController, LoadingController } from 'ionic-angular';

import { User } from '../../providers/user';


/*
  Generated class for the AccountNameForm component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'account-name-form',
  templateUrl: 'account-name-form.html'
})
export class AccountNameFormComponent {
  account: { displayName?: string } = {
    displayName: ''
  };
  submitted: boolean = false;

  constructor(
    public user: User,
    public loading: LoadingController,
    public alert: AlertController
  ) {
    this.account.displayName = this.user.profile().displayName;
  }

  public onRename(form) {
    let loader = this.loading.create({
      content: 'Please wait..',
      duration: 10000
    });
    this.submitted = true;
    if (form.valid) {
      loader.present().then(() => {
        this.user.profile().updateProfile({
          displayName: this.account.displayName
        }).then(() => {         
          this.user.profileSync();  // persists on db
          loader.dismiss().then(() => {
            this.showAlert('Danke', 'Wir nennen dich ab nun '+ this.account.displayName +'.');
          });
        }, (e) => {
          loader.dismiss().then(() => {
            this.errorHandler(e);
          });
        });
      });
    }
  }

  showAlert(title, subtitle) {
    let alert = this.alert.create({
      title: title,
      subTitle: subtitle,
      buttons: ['OK']
    });
    return alert.present();
  }

  errorHandler(error) {
    let errorCode = error.code;
    let errorMessage = error.message;
    let handler = User.errorHandler(errorCode, errorMessage);
    this.showAlert(handler.title, handler.message);
  }
}


// WEBPACK FOOTER //
// ./src/components/account-name-form/account-name-form.ts